<template>
    <div class="input-text">
        <label for="name" class="input-text" :class="{'error': error && value.length < 3}">
            <span class="input-text__label">Imię:</span>
            <input class="input-text__input" maxlength="20" type="text" name="name" id="name" v-model="value" @keydown="isLetter">
        </label>
    </div>
</template>

<script>
export default {
    name: "InputText",
    props: {
        data: {
            type: String, 
        },
        error: {
            type: Boolean,
        }
    },    
    data() {
        return {
            value: ''
        };
    },
    watch: {
        value() {
            this.$emit("setName", this.value);
        }
    },
    methods: {
        isLetter(e) {
            if ((!/^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]/.test(e.key) && e.key !== 'Backspace')) {
                e.preventDefault();
            }
        }
    },   
    mounted() {
        this.value = this.data;
    }
};
</script>